import React, { Component } from 'react';
import Button from '../../UI/Button/Button';
import strings from '../../../assets/localization';
import classes from './AppleLogin.module.css';
import AppleLogin from 'react-apple-login';

export default class AppleLoginButton extends Component {
  render () {
    return (
      <AppleLogin
        clientId={this.props.queryParams.client_id}
        redirectURI={this.props.queryParams.redirect_uri}
        responseType={this.props.queryParams.response_type}
        responseMode={this.props.queryParams.response_mode}
        scope={this.props.queryParams.scope}
        render={({onClick}) => (
          <Button
            style={this.props.style}
            btnType='Apple'
            clicked={onClick}
          >
            <div className={classes.InnerWrapper}>
              <svg className={classes.AppleSvg}>
                <use xlinkHref='/sprites.svg#icon-apple' />
              </svg>
              <span>{this.props.children ? this.props.children : strings.signUpWithApple}</span>
            </div>
          </Button>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/AppleLogin/AppleLogin.js